import { BestPlayers, EditMatch, GoalkeeperRatings, Match } from "@/models";
import { ApiResponse } from "./../models/api.model";
import axios from "./axios";

export default {
  getMatch(matchId: number) {
    return axios.get().get<ApiResponse<Match>>(`/match/${matchId}`);
  },
  putMatch(matchId: number, editMatch: EditMatch) {
    return axios.get().put(`/match/${matchId}`, editMatch);
  },
  putBestPlayers(matchId: number, bestPlayers: BestPlayers) {
    return axios.get().put(`/match/${matchId}/bestplayer`, bestPlayers);
  },
  putGoalkeeperRating(matchId: number, goalkeeperRatings: GoalkeeperRatings) {
    return axios.get().put(`/match/${matchId}/goalkeeper`, goalkeeperRatings);
  }
};
